import React, { useState } from 'react'
import AddTabsMenu from './menu/AddTabsMenu'
import TabComments from './comments/TabComments'
import TabChanges from './changes/TabChanges'

const AddTabs = ({ comments, changes, supplyOrderId, supplyBillId, supplierId, writeOffActId }) => {

    const [menuSelect, setMenuSelect] = useState('comments')

  return (
    <div className='addTabs'>
        <AddTabsMenu 
            menuSelect={menuSelect}
            setMenuSelect={setMenuSelect}
        />
        {
            menuSelect === 'comments' ?
                <TabComments 
                    comments={comments}
                    supplyOrderId={supplyOrderId}
                    supplyBillId={supplyBillId}
                    supplierId={supplierId}
                    writeOffActId={writeOffActId}
                /> 
            :
            menuSelect === 'changes' ? 
                <TabChanges 
                    changes={changes}
                /> 
            : ''
        }
    </div>
  )
}

export default AddTabs